import { combineReducers } from "redux"
import common from "./redux/commons/reducer"

const rootReducer = combineReducers({
    common
});

export default rootReducer